'use client'

import { useReportWebVitals } from 'next/web-vitals'
import { debounce } from 'helper/util';

export function WebVitals() {
    const track = debounce(() => {
        console.log('tracker called')
        window._satellite?.track('page_load');
    }, 1000);

    useReportWebVitals((metric) => {
        if (window.digitalData?.page?.pageInfo) {
            window.digitalData.page.pageInfo = window.location.pathname
        }
        switch (metric.name) {
            case 'FCP': {
                // handle FCP results
                if ('/temp-login' !== window.location.pathname) {
                    track();
                }
            }
        }
    })
}